import ReceiptPage, { ReceiptPageProps } from './ReceiptPage';
import withInteractor from './ReceiptPage.interactor';
import withPresenter from './ReceiptPage.presenter';

export type { ReceiptPageProps };
export default withInteractor(withPresenter(ReceiptPage));
